import { SetValueFunction } from "./onchange_callbacks";

export const setSampleSizeMehadrinISR = ({ count, use_bulk_edit }: { count: number; use_bulk_edit: number | string }, setValue: SetValueFunction): void => {
    if (!count || !use_bulk_edit) {
        return;
    }
    setValue("sample_size", Math.round(Number(count) * Number(use_bulk_edit)));
};
